import {Box} from '@buncha/components/core/view';
import React from 'react';

const CameraModal = () => {
  return <Box />;
};

export default React.memo(CameraModal);
